import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

// Safely serialize single values and multiple selected filters.
const buildQueryString = (params) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== "") {
          query.append(key, String(item));
        }
      });
    } else {
      query.set(key, String(value));
    }
  });

  return query.toString();
};

export const productApiSlice = createApi({
  reducerPath: "productsApi",
  baseQuery: fetchBaseQuery({ baseUrl: apiUrl }),

  endpoints: (builder) => ({
    fetchAllFilteredProducts: builder.query({
      query: ({
        category,
        minPrice,
        maxPrice,
        productName,
        searchTerm,
        brand,
        flavor,
        seller,
        inStock,
        onSale,
        page = 1,
        limit = 70,
      }) => {
        const queryParams = buildQueryString({
          category,
          minPrice,
          maxPrice,
          productName,
          searchTerm,
          brand,
          flavor,
          seller,
          inStock,
          onSale,
          page,
          limit,
        });

        return `/products/get/allProducts?${queryParams}`;
      },
    }),

    fetchAllCategory: builder.query({
      query: () => "/category",
    }),

    fetchCategoriesName: builder.query({
      query: () => "/categories",
    }),

    fetchAllOffers: builder.query({
      query: () => "/coupon",
    }),

    fetchProductById: builder.query({
      query: (id) => `/products/${id}`,
    }),

    fetchProductsByCategory: builder.query({
      query: (id) => `/products/category/${id}`,
    }),

    fetchProductsByVendor: builder.query({
      query: (id) => `/products/vendor/${id}`,
    }),

    fetchgetHome: builder.query({
      query: () => "/products/get/homeProducts",
    }),

    fetchDiscountedProducts: builder.query({
      query: () => "/products/get/discounted",
    }),
  }),
});

export const {
  useFetchAllFilteredProductsQuery,
  useFetchAllCategoryQuery,
  useFetchAllOffersQuery,
  useFetchCategoriesNameQuery,
  useFetchProductByIdQuery,
  useFetchProductsByCategoryQuery,
  useFetchProductsByVendorQuery,
  useFetchgetHomeQuery,
  useFetchDiscountedProductsQuery,
} = productApiSlice;

export const productApiReducer = productApiSlice.reducer;